import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ISetting } from '../interfaces/Setting.js';

/**
 * Setting
 */
class Setting extends ABaseModel implements ISetting {
  id: number;
  type: number;
  name: string;
  value: any;
  localeCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Setting };
